// App.js
import React from 'react';
import './App.css';
import BlockedSubscription from './components/BlockedSubscription';
function App() {
  return (
    <div className="container">
      <BlockedSubscription />
    </div>
  );
}

export default App;